import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as headerActions from '../../../actionCreators/header';
import './SearchBar.scss';
import Customevent from '../../../utils/Customevent';
import { langCodeAllowed } from '../../../locales';
class SearchBar extends PureComponent {
  static propTypes = {
    searchData: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.focusedData = {};
    this.modifiedSearchResult = [];
    this.state = {
      showTrending: false,
      showSearchResult: false,
      searchInputValue: '',
    };
  }

  componentDidMount() {
    window.callback = response => {
      const event = new Customevent('SEARCH_CALLBACK', { detail: { response } });
      event.dispatch();
    };
  }

  getSearchResult(context, searchValue) {
    setTimeout(() => {
      if (searchValue.length) {
        const input = searchValue;
        const redirectPath = `/search?q=${input}`;
        window.ReactPixel.default.track('Search', {
          content_type: 'product',
          search_string: searchValue,
          success: 1,
        });
        if (window.dtm.LenskartRewamp)
          window.dtm.LenskartRewamp.searchpage.click.searchSuggestion(input);
        _gaq.push(
          [
            '_trackEvent',
            'Header',
            'search',
            `page: ${document.location.href}${document.location.href}`,
          ],
          [
            'ninja._trackEvent',
            'Header',
            'search',
            `page: ${document.location.href}${document.location.href}`,
          ]
        );
        context.setState({ showTrending: false, showSearchResult: false });
        context.props.history.push(redirectPath);
      }
    }, 300);
  }

  escapeHtml(e) {
    const s = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;',
    };
    return e.replace(/[&<>"']/g, e => {
      return s[e];
    });
  }

  searchBarEventHandler(eventType, event) {
    const { headerActions } = this.props;
    switch (eventType) {
      case 'keyup':
        if (event.target.value.length === 0) {
          this.setState({
            showTrending: true,
            showSearchResult: false,
            searchInputValue: event.target.value.trim(),
          });
        } else if (
          event.target.value.length > 0 &&
          event.target.value !== this.state.searchInputValue &&
          !Object.keys(this.focusedData).length
        ) {
          this.setState({
            showTrending: false,
            showSearchResult: true,
            searchInputValue: event.target.value.trim(),
          });
          headerActions.searchInputChange(event.target.value);
        }
        break;
      case 'keydown':
        if (event.which === 38) {
          if (this?.focusedData?.uniqueId) {
            const currentIndex = this.modifiedSearchResult.findIndex(
              data => data.uniqueId === this?.focusedData?.uniqueId
            );
            const nextSelection =
              this.modifiedSearchResult[currentIndex - 1] || this.modifiedSearchResult[0];
            document
              .getElementById(this.modifiedSearchResult[currentIndex].uniqueId)
              .classList.remove('hover');
            document.getElementById(nextSelection.uniqueId).classList.add('hover');
            this.focusedData = nextSelection;
          } else {
            this.focusedData = this.modifiedSearchResult[0];
            document.getElementById(this.focusedData.name).classList.add('hover');
          }
          event.target.value = this.focusedData.name.trim();
        }
        if (event.which === 40) {
          if (this?.focusedData?.uniqueId) {
            const currentIndex = this.modifiedSearchResult.findIndex(
              data => data.uniqueId === this?.focusedData?.uniqueId
            );
            const nextSelection =
              this.modifiedSearchResult[currentIndex + 1] || this.modifiedSearchResult[0];
            document
              .getElementById(this.modifiedSearchResult[currentIndex].uniqueId)
              .classList.remove('hover');
            document.getElementById(nextSelection.uniqueId).classList.add('hover');
            this.focusedData = nextSelection;
          } else {
            this.focusedData = this.modifiedSearchResult[0];
            document.getElementById(this?.focusedData?.uniqueId).classList.add('hover');
          }
          event.target.value = this.focusedData.name.trim();
        }
        if (event.which === 13) {
          event.preventDefault();
          const input = event.target.value.trim();
          if (window.dtm.LenskartRewamp)
            window.dtm.LenskartRewamp.searchpage.click.searchSuggestion(input);
          this.focusedData = {};
          this.getSearchResult(this, input);
        }
        if (
          event.which === 220 ||
          event.which === 219 ||
          event.which === 221 ||
          event.key === '(' ||
          event.key === ')' ||
          event.key === '?' ||
          event.key === '%'
        ) {
          event.preventDefault();
        }
        break;
      case 'focus':
        setTimeout(() => {
          this.setState({ showTrending: true, showSearchResult: false });
          this.focusedData = {};
        }, 200);
        break;
      case 'blur':
        setTimeout(() => {
          this.setState({ showTrending: false, showSearchResult: false });
          this.focusedData = {};
        }, 200);
        break;

      default:
        break;
    }
  }
  boldData(data) {
    const searchDataValue = this.inputRef ? this.inputRef.value.trim() : '';
    const dataParamValue = searchDataValue && searchDataValue.replace(/[\])}?[{(]/g, '');
    const searchValue = new RegExp(dataParamValue, 'i');
    return data.replace(searchValue, `<span class="menu-list">${dataParamValue}</span>`);
  }

  render() {
    const { searchData, dataLocale, currencyMark, cartData, localeInfo } = this.props;
    const currencyCode =
      cartData && cartData?.result?.currencyCode
        ? cartData?.result?.currencyCode
        : dataLocale.CURRENCY_CODE;
    const currencySymbol = currencyMark[currencyCode];
    const { trendingSearch_desktop } = langCodeAllowed[localeInfo.countryCode];
    const { showTrending, showSearchResult } = this.state;
    let popularProducts = [];
    const keywordSuggestions = [];
    if (searchData) {
      const updatedProductRecomendation = searchData.productRecommendations.map((item, index) => {
        item.uniqueId = `product${index}`;
        return item;
      });
      searchData.typeAhead.forEach((item, index) => {
        keywordSuggestions.push({
          name: item,
          uniqueId: `type${index}`,
        });
      });
      popularProducts = [...updatedProductRecomendation];
    }
    const matchingLength = keywordSuggestions.length > 0 || false;
    this.modifiedSearchResult = [].concat(keywordSuggestions, popularProducts);
    const {
      WHAT_ARE_YOU_LOOKING_FOR,
      MATCHING_KEYWORDS,
      PRODUCT_RECOMMENDATIONS,
      TRENDING_SEARCH,
    } = dataLocale;
    return (
      <div className="search">
        <div className="search_toggle-menu">
          <div className="search_block">
            <form>
              <div>
                <input
                  ref={input => {
                    this.inputRef = input;
                  }}
                  autoComplete="off"
                  className="search_input-bar autoSuggest"
                  name="q"
                  placeholder={WHAT_ARE_YOU_LOOKING_FOR}
                  type="text"
                  onBlur={event => {
                    this.searchBarEventHandler('blur', event);
                  }}
                  onFocus={event => {
                    this.searchBarEventHandler('focus', event);
                  }}
                  onKeyDown={event => {
                    this.searchBarEventHandler('keydown', event);
                  }}
                  onKeyUp={event => {
                    this.searchBarEventHandler('keyup', event);
                  }}
                />
                <i
                  aria-hidden="true"
                  className="search-icon"
                  onClick={() => this.getSearchResult(this, this.state.searchInputValue)}
                ></i>
                {searchData && showSearchResult && (
                  <div className={`search-result ${matchingLength ? 'p-10' : ''}`}>
                    <div className={matchingLength ? 'padding-b15' : ''}>
                      {matchingLength && (
                        <div className="text-capitalize search-text-heading">
                          {MATCHING_KEYWORDS}
                        </div>
                      )}
                      {keywordSuggestions.map((data, index) => {
                        return (
                          <div
                            dangerouslySetInnerHTML={{ __html: this.boldData(data.name) }}
                            key={index}
                            className="suggestions-list"
                            id={data.uniqueId}
                            role="presentation"
                            onClick={() => this.getSearchResult(this, data.name)}
                          ></div>
                        );
                      })}
                    </div>
                    <div className="">
                      {popularProducts.length > 0 && (
                        <div className="text-capitalize search-text-heading">
                          {PRODUCT_RECOMMENDATIONS}
                        </div>
                      )}
                      {popularProducts.map((data, index) => {
                        return (
                          <div key={index} className="popular-product-container" id={data.uniqueId}>
                            <Link
                              to={{
                                pathname: data.product_url.substring(
                                  data.product_url.indexOf('.com/') + 4
                                ),
                                state: { productId: '', section: 'prod' },
                              }}
                            >
                              <div className="info">
                                <div className="layout">
                                  <div className="image">
                                    <img
                                      alt="prod"
                                      src={data.image_url}
                                      onError={() => {
                                        this.src =
                                          'http://sol-us-prod-1.cloudapp.net/cilory/ina.jpg';
                                      }}
                                    />
                                  </div>
                                  <div className="text">
                                    <div className="brand">{data.brand_name}</div>
                                    <div
                                      className="name"
                                      dangerouslySetInnerHTML={{ __html: data.name }}
                                    ></div>
                                  </div>
                                </div>
                                <div className="price">
                                  {currencySymbol}&nbsp;{data.prices[0].price}
                                </div>
                              </div>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {showTrending && (
                  <div className="trending">
                    <div className="trending_block">
                      <h3> {TRENDING_SEARCH} </h3>
                      <ul className="trending_list menu-link">
                        {trendingSearch_desktop?.map((item, index) => {
                          return (
                            <li key={index}>
                              <a
                                dangerouslySetInnerHTML={{ __html: item.name }}
                                href={item.url}
                              ></a>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  searchData: state.header.searchData,
  dataLocale: state.locale,
  localeInfo: state.common.localeInfo,
  currencyMark: state.common.currencyMark,
});

function mapDispatchToProps(dispatch) {
  return {
    headerActions: bindActionCreators(headerActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);
